import { Builder } from '@builder.io/react'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'

interface Props {
  backgroundColor: string
}

const MentionMe = ({ backgroundColor }: Props) => {
  const { customer } = useSelector((state: RootState) => state.accountSummary)

  useEffect(() => {
    if (typeof window?.yotpoWidgetsContainer?.initWidget !== 'undefined') {
      window.yotpoWidgetsContainer.initWidgets()
    }
  }, [])
  return (
    <>
      <Helmet>
        <h2 className="mt-8 mb-4 text-center text-2xl text-primary sm:text-4xl">Treat a Friend</h2>
      </Helmet>
      <div className="" style={{ backgroundColor }}>
        <div
          id="swell-customer-identification"
          data-authenticated="true"
          data-email={customer?.email}
          data-id={customer?.customerId}
          className="display:none;"
        ></div>
        {process.env.GATSBY_YOTPO_REFERRAL_REWARDS && (
          <div
            className="yotpo-widget-instance"
            data-yotpo-instance-id={process.env.GATSBY_YOTPO_REFERRAL_REWARDS}
          ></div>
        )}
      </div>
    </>
  )
}

export default MentionMe

Builder.registerComponent(MentionMe, {
  name: 'MentionMe',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'gray'
    }
  ]
})
